import { render, staticRenderFns } from "./LandingFreePremium.vue?vue&type=template&id=068f226a&scoped=true"
import script from "./LandingFreePremium.vue?vue&type=script&lang=js"
export * from "./LandingFreePremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068f226a",
  null
  
)

export default component.exports